import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'

import InfoBanner from 'js/components/shared/InfoBanner';

import styles from './BusinessCodeBanner.module.scss'

const cx = classnames.bind(styles)

const BusinessCodeBanner = ({ data, className }) => {
  const {
    companyName,
    companyLabel,
    loyaltyCard,
    loyaltyLabel,
  } = data

  return (
    <InfoBanner type="info" color="b2b" size="md" className={className}>
      <ul>
        {!!companyName && (
          <li>
            {`${companyLabel}: `}
            <span className={cx('highlight')}>
              {companyName}
            </span>
          </li>
        )}
        {!!loyaltyCard && (
          <li>
            {`${loyaltyLabel}: ${loyaltyCard}`}
          </li>
        )}
      </ul>
    </InfoBanner>
  )
}

BusinessCodeBanner.propTypes = {
  data: PropTypes.shape({
    companyName: PropTypes.string,
    companyLabel: PropTypes.string,
    loyaltyCard: PropTypes.string,
    loyaltyLabel: PropTypes.string,
  }).isRequired,
}

export default BusinessCodeBanner
